import { ctor } from 'from2';
import { async } from 'regenerator-runtime';
import {
  req,
  imgServer,
  googlePlaceDataAPI,
  getWebsiteData,
} from '../js/config';
import { currencyFormatter } from '../js/base';
//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";
let PageData = {};
const Initialize = async () => {
  try {
    await getPageData();
    console.log('getPageData', PageData);

    await generatePageHTML();

    await loadJavascriptNow();

    const loader = document.querySelector('.loader');
    loader.className += ' hidden'; // class "loader
  } catch (err) {
    window.location = 'index.html';
  }
};

const getPageData = async () => {
  let WebData = await getWebsiteData();
  PageData = WebData.filter((x) => x.attributes.Status === 'Available');
};

const generatePageHTML = async () => {
  document.querySelector('#copyrightYearsFooter').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  document.querySelector('#copyrightYearsMobileMenu').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  let testimonials = await googlePlaceData();

  if (testimonials != null) {
    await updateCurrentDayHours(testimonials.opening_hours);

    await phoneNumber(testimonials.formatted_phone_number);

    await address(testimonials.formatted_address);
    await generateSideBarDealerInfoData(testimonials);
  }
  await sidebarRecentListings();
};

const updateCurrentDayHours = async (h) => {
  let currentDay = new Date().getDay();
  currentDay == 0 ? (currentDay = 7) : currentDay;

  document.querySelector('#currentDayHours').innerHTML =
    h.weekday_text[currentDay - 1];

  let tpa = '';
  for (let i = 0; i < h.weekday_text.length; i++) {
    tpa += `<li>${h.weekday_text[i]}</li>`;
  }
  document.querySelector('#workingHours').innerHTML = tpa;
};
const phoneNumber = async (p) => {
  document.querySelector('#phoneNumber').innerHTML =
    '<a href="tel:+' + p.replace(/[\s\-\(\)]+/g, '') + ' "> ' + p + '</a>';
  document.querySelector('#footerPhoneNumber').innerHTML =
    '<a href="tel:+' + p.replace(/[\s\-\(\)]+/g, '') + ' "> ' + p + '</a>';
};
//<a href="geo:37.421999,-122.0862462" target="_blank">
//Visit Us: 1600 Amphitheatre Parkway, Mountain View, CA
//</a>

const address = async (a) => {
  document.querySelector('#address').innerHTML =
    '<a href="https://www.google.com/maps?q=' +
    a +
    '" target="_blank">' +
    a +
    '</a>';
  document.querySelector('#footerAddress').innerHTML =
    '<a href="https://www.google.com/maps?q=' +
    a +
    '" target="_blank">' +
    a +
    '</a>';
};

const generateSideBarDealerInfoData = async (di) => {
  let tpd = '';

  tpd += `<div class="dealer-profile">
<div class="profile-image">
    <img src="assets/images/author-5.jpg" alt="">
</div>
<div class="profile-content">
    <h5 class="name"><a href="#">Hansen Truck & Car Sales</a></h5>
    <div class="profile-rating">
        <ul class="star">
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li class="rating-on"><i class="ion-android-star"></i></li>
            <li><i class="ion-android-star"></i></li>
        </ul>
        <span>(${di.rating} Google Rating)</span>
    </div>
</div>
</div>
<ul class="info-items">
<li>
    <i class="ion-ios-location"></i>
        <span>${di.formatted_address}</span>
        <span></span>
</li>
<li>
    <i class="ion-ios-telephone"></i>
    <span><a class="call" href="tel:${di.formatted_phone_number}">${di.formatted_phone_number}</a></span>
</li>
<li>
    <i class="ion-android-mail"></i>
    <span><a
            href="mailto:hansentc@yahoo.ca">hansentc@yahoo.ca</a></span>
</li>

</ul>`;
  document.querySelector('#dealerInfo').innerHTML = tpd;
};

const sidebarRecentListings = async () => {
  let tprc = '';

  PageData.slice(0, 10).forEach((d) => {
    tprc += `<li>
        <div class="single-listing">
            <div class="listing-image">
                <a href="cardetail.html?id=${
                  d.id
                }&location=brampton&used-car-for-sale=${
      d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
    }">
                    <img src="${
                      imgServer +
                      d.attributes.Images.data[0].attributes.formats.thumbnail
                        .url
                    }" alt="">
                </a>
            </div>
            <div class="listing-content">
                <h2 class="title"><a href="cardetail.html?id=${
                  d.id
                }&location=brampton&used-car-for-sale=${
      d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
    }">${
      d.attributes.Year + ' ' + d.attributes.Make + ' ' + d.attributes.Model
    } </a></h2>
                <div class="price">
                    <span class="price-amount">${currencyFormatter.format(
                      d.attributes.Price
                    )}</span>
                </div>
            </div>
        </div>
    </li>`;
  });

  document.querySelector('#pageSidebarNewlyAdded').innerHTML = tprc;
};
const googlePlaceData = async () => {
  const data = await googlePlaceDataAPI();
  console.log('🚀 ~ file: main.js ~ line 162 ~ googlePlaceData ~ data', data);
  return data;
};
const loadJavascriptNow = async () => {
  const script = document.createElement('script');
  script.src = 'assets/js/main.js';

  // Append to the `head` element
  document.head.appendChild(script);
};

Initialize();
